<template>
    <div class="shipsDialog" v-if="dialogVisible">
        <el-dialog @close='cancel' title="批量发货导入" :visible.sync="dialogVisible" width="600px">
            <div class="title">Excel文件内容格式为：订单号，快递公司，快递单号</div>
            <el-upload class="upload-demo" ref="myUpload" action="" :auto-upload="false" :on-change="onChangeFile"
                       accept=".xls,.xlsx" :file-list="fileList" :on-remove="handleRemove">
                请选择导入文件
            </el-upload>
            <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="handleImport">导入</el-button>
    </span>
        </el-dialog>
    </div>
</template>

<script>
    import {importShipInfoData} from 'api/brandBusiness'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: 'shipsDialog',
        data() {
            return {
                dialogVisible: false,
                formData: new FormData(),
                fileList: []
            }
        },
        mounted() {
        },
        methods: {
            openDialog() {
                this.dialogVisible = true
            },
            cancel() {
                this.formData = new FormData()
                this.fileList = []
                this.$refs.myUpload.clearFiles()
                this.dialogVisible = false
            },
            onChangeFile(file) {
                this.fileList = [
                    {
                        name: file.name,
                        url: '',
                    }
                ]
                this.formData.append('importexcel', file.raw)
            },
            handleRemove() {
                this.fileList = []
                this.formData = new FormData()
            },
            handleImport() {
                if (!this.fileList.length) {
                    this.$message.error('请选择导入的文件')
                } else {
                   this._importShipInfoData()
                }
            },
            _importShipInfoData() {
                this.setLoading(true)
                importShipInfoData({
                    data: this.formData,
                    success: data => {
                        this.setLoading(false)
                        this.$alert('<div class="tc-black">成功：<span class="tc-green">' + data.data.successcount + '</span> 条</div><div>失败：<span class="tc-red">' + data.data.failcount + '</span> 条</div>',
                            '导入结果', {
                                dangerouslyUseHTMLString: true
                            })
                        this.cancel()
                        this.$emit('refresh')
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            ...mapActions([
                'setLoading'
            ])
        },
        filters: {},
        watch: {},
        computed: {},
        components: {}
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .shipsDialog {
        text-align: center;
        .title {
            color: #303133;
            font-size: 14px;
            margin-bottom: 20px;
        }
        .upload-demo {
            .el-upload.el-upload--text {
                background: #F5F7FA;
                width: 100%;
                height: 40px;
                line-height: 40px;
            }
            color: #C0C4CC;
        }
    }
</style>
